// action
import {
    SAVE_INSTITUTE_TEST_PRICING_MASTER,
    SAVE_INSTITUTE_TEST_PRICING_MASTER_FAIL,
    SAVE_INSTITUTE_TEST_PRICING_MASTER_SUCCESS,
    SAVE_INSTITUTE_TEST_PRICING_MASTER_RESET
} from '../action/saveInstituteTestPricingMasterAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_INSTITUTE_TEST_PRICING_MASTER:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_INSTITUTE_TEST_PRICING_MASTER_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_INSTITUTE_TEST_PRICING_MASTER_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_INSTITUTE_TEST_PRICING_MASTER_RESET:
            return initialState
        default:
            return state
    }
}